<template>
  <div>
    <OperationLog
      ref="operationLog"
      :searchFields="searchFields"
      :tableData="tableData"
    >
      <template slot="optType" slot-scope="text">
        {{typeFormate(text)}}
      </template>
    </OperationLog>
  </div>
</template>
<script>
import OperationLog from '@/components/OperationLog'
import api from '@/api/index'
import { SimpleUserList } from '@/api/login'
export default {
  data () {
    return {
      searchFields: [
        {
          type: 'select',
          name: 'optType',
          placeholder: this.$t('authority_account_select_content'),
          options: [
            { value: 1, label: this.$t('childAct_新增') },
            { value: 5, label: this.$t('childAct_冻结') },
            { value: 4, label: this.$t('childAct_启用') },
            { value: 2, label: this.$t('childAct_编辑') }
          ]
        },
        { type: 'select', name: 'optSubject', isSearch: true, dataType: String, placeholder: this.$t('childAct_被操作人姓名查询'), options: this.optSubjectData }
      ],
      tableData: {
        apiPath: api.GetOptLog1,
        baseURL: api.SSO_URL,
        defaultParam: {
          systemCode: 'OPEN_API_PORTAL',
          optModule: 'OPEN_API_USER',
          optSubject: '',
          optType: ''
        },
        columns: [
          { title: this.$t('developer_operator'), dataIndex: 'optName', width: 124 },
          { title: this.$t('developer_operation_type'), dataIndex: 'optType', scopedSlots: { customRender: 'optType' }, width: 120 },
          { title: this.$t('authority_account_OperatedPerson'), dataIndex: 'optedName', scopedSlots: { customRender: 'optedName' }, width: 220 },
          { title: this.$t('developer_operation_content'), dataIndex: 'optContext', scopedSlots: { customRender: 'optContext' }, align: 'left' },
          { title: this.$t('common_conj_time'), dataIndex: 'createTime', scopedSlots: { customRender: 'createTime' }, width: 155 }
        ],
        optSubjectData: [],
        scrollX: 1620,
        scrollY: 600
      }
    }
  },
  mounted () {
    this.$EventBus.$on('getTarget', (data) => {
      if (data === '') return
      SimpleUserList({
        pageNum: 1,
        pageSize: 200,
        paging: true,
        realName: data,
        systemCode: 'OPEN_API_PORTAL'
      }).then((res) => {
        this.searchFields[1].options = res.dataList.map((item) => {
          return { label: item.realName, value: item.userId }
        })
        this.$forceUpdate()
      })
    })
    const rect = this.$refs['operationLog'].$el.getBoundingClientRect()
    const winH = window.innerHeight
    this.tableData.scrollY = winH - rect.top - 42 - 40 - 48
  },
  components: {
    OperationLog
  }
}
</script>

<style scoped lang="less">
/deep/.fixed-btn-view {
  bottom: 50px;
  border: none;
}
</style>
